"use client";
import { LiveSharePage } from "@highway/design-system";

export default function LiveShare() {
    return (
        <>
            <title>Appreciation</title>
            <LiveSharePage
                tool="appr"
                baseUrl="appreciation"
                renderHeaderText={({ clientName }) => `Appreciation for ${clientName}`}
                renderButtonText={({ isMeeting }) => (isMeeting ? "View report" : "View flyer")}
                hasReportRoute
            />
        </>
    );
}
